import { render, staticRenderFns } from "./Politics.vue?vue&type=template&id=9734e9fc&scoped=true"
import script from "./Politics.vue?vue&type=script&lang=js"
export * from "./Politics.vue?vue&type=script&lang=js"
import style0 from "./Politics.vue?vue&type=style&index=0&id=9734e9fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9734e9fc",
  null
  
)

export default component.exports